import { WebStorageStateStore } from "oidc-client-ts";
import { useStore } from "react-redux";

export const cognitoAuthConfig = {
    authority: process.env.REACT_APP_COGNITO_AUTHORITY,
    client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
    redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URI,
    response_type: process.env.REACT_APP_COGNITO_RESPONSE_TYPE,
    scope: process.env.REACT_APP_COGNITO_SCOPE,
    automaticSilentRenew: true,
    loadUserInfo: true,

    onSigninCallback: () => {
        const path = sessionStorage.getItem("post_login_redirect") || "/";

        sessionStorage.removeItem("post_login_redirect");
        window.history.replaceState({}, document.title, path);
    },
    useStore: new WebStorageStateStore({ store: window.localStorage }),
};